<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <admin-sidebar-menu v-if="admin" />
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Task List Assignment</h3>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

          <div class="content-main-wrapper signin-form add_account_form center">
            <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
              <form @submit.prevent="updateMenteesTasklist">
                <div v-if="loading === false">
                  <div v-if="group_tasklists.length > 0" class="row margin-bottom-15">
                    <div class="col-12 col-sm-12">
                      <label
                        for="roles"
                        class="col-12">Tasklists to be assigned : </label>
                      <div class="margin-bottom-10"></div>
                      <b-card no-body>
                        <b-tabs card>
                          <b-tab v-if="group_tasklist.tasklists.length > 0" :title="group_tasklist.name" v-for="(group_tasklist, index) in group_tasklists" v-bind:key="index">
                            <div class="margin-bottom-10"></div>
                            <b-card-text>
                              <div class="col-12 col-sm-12 override-padding tasklist-assign-wrapper" v-for="(option, key, index) in group_tasklist.tasklists">
                                <div class="chkboxwrapper">
                                  <input :value="option.id" :id="option.id" type="checkbox" name="tasklist_assigned" v-model="tasklist_assigned" class="float-left" style="margin-top: 2px;">
                                  <label :for="option.name" class="float-left" style="margin-left: 4px;">{{ option.name }}</label>
                                  <div style="clear: both;"></div>
                                </div>
                              </div>
                            </b-card-text>
                          </b-tab>
                        </b-tabs>
                      </b-card>
                    </div>
                  </div>
                </div>
                <div class="submit margin-bottom-15 float-right">
                  <button type="submit" class="btn btn-info btn-md">Update</button>
                </div>
              </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import { store } from '../../store/store';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  data() {
   return {
      loading: false,
      tasklist_assigned: [],
      taskListsNames: [],
      group_tasklists: [],
      admin: false,
    }
  },
  components: {
    UserMenu,
    GoBack,
    AdminSidebarMenu
  },
  methods: {
    isUser() {
      if(this.$route.params.user_id) {
          return false;
      }
      else {
          return true;
      }
    },
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        this.pwd_update();
      }).catch(() => {
        // catches the error;
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    navigate(pathUrl) {
      router.push({
        path: pathUrl,
        force: true
      });
    },
    isInArray(value, array) {
      return array.indexOf(value) > -1;
    },
    updateMenteesTasklist () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        axios('/mentees-tasklist-update/' + this.$route.params.student_id,
          {
            method: 'POST',
            data: {"tasklists_assigned": this.tasklist_assigned},
          }
        )
       .then((resp) => {
          this.flash({ message: resp.data.successMsg, variant: 'success' });
          this.navigate("/group-users/" + this.$route.params.group_id);
        })
       .catch(error => {

       });
      }).catch(() => {
        // catches the error;
      });
    },
  },
  created: function() {
    this.loading = true;
    document.body.className = 'profile-page';

    var userAccountId = '';
    if(store.state.user_accountid) {
      userAccountId = store.state.user_accountid;
    }
    var roles = store.state.roles;
    if((roles.indexOf('ROLE_ADMIN') > -1) || (store.state.switch_admin_username)) {
      this.admin = true;
    }
    this.get_url = '/user-profile/' + this.$route.params.student_id;
    axios(this.get_url,
      {
        method: 'POST',
        data: {
               "accountId": userAccountId,
        }
      }
    )
    .then(resp => {
      this.loading = false;
      for(var j=0; j < resp.data.user.taskLists.length; j++) {
        this.tasklist_assigned.push(resp.data.user.taskLists[j].id);
      }
    })
    .catch(error => {
      this.loading = false;
    })
  },
  mounted() {

      axios.get('/tasklists-group', {
        params: {
          group_id: this.$route.params.group_id,
        }
      })
      .then(response => {
            this.group_tasklists = response.data;
       })
      .catch(error => {

      });

  },
}
</script>

<style scoped>
.custom-select {
  height: 40px;
}
.tasklist-assign-wrapper label {
    font-weight: normal;
}
.card {
  background: none !important;
}

</style>



// WEBPACK FOOTER //
// src/components/primaryadmin/edit_student_tasklist_assignment.vue